export function submitPageInputs (isContinueButtonLoading , pageRoute, previousRoute, nextRoute, isFormFilled, isDonor =0, isFormsubmitted = false) {
    let comp = this;
    let bodyFormData = new FormData();
    comp.$root.formData.isDonorFilled = isDonor
    // last_step_name:'Pursonal Info',
    //     last_step: 3,
    //     form_filled:true,
    bodyFormData.append("form_data", JSON.stringify(comp.$root.formData));
    bodyFormData.append("last_step_name", previousRoute); //personal-info
    bodyFormData.append("next_route", nextRoute);
    bodyFormData.append("form_filled", isFormFilled)
    bodyFormData.append("is_doner_filled", comp.$root.formData.isDonorFilled)
    if(comp.$root.formData.haveNic =='No'){
        bodyFormData.append("guardian_nic", comp.$root.formData.guardian_nic)

    }
    console.log("formData ",comp.$root.formData)
    console.log("next route ", nextRoute)
    let kyc_token = comp.$root.formData.kyc_token +'.'+ comp.$root.formData.color_code4 +'.'+ comp.$root.formData.color_code12;
    comp.$http
        .post(comp.$baseURL + "/kycForm/submitAccountInfoKycForm", bodyFormData, {
            headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
        })
        .then(function (response) {
            //handle success
            console.log("kyc token....",kyc_token)
            console.log("successfully submitted--------------");
            console.log(response);

            isContinueButtonLoading = false;
            comp.$root.isFormSubmitted = isFormsubmitted;
            comp.$router.push(pageRoute)

        })
        .catch(function (response) {
            //handle error
            console.log(response);
            comp.$buefy.toast.open({
                message: "Failed to submit form data",
                type: "is-danger",
            });
        });
}

export function getBranchesList(){
    try{
      let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
      this.$http
          .post(this.$baseURL + "/kycForm/getBranches", {},{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            //console.log(response.data.data.branches);
            this.$root.dataLists.branchListArray = response.data.data.branches;
          })
    }catch(err){
      console.log(err)
    }
  }

  export function  getOtherBankList(){
    try{
      let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
      this.$http
          .post(this.$baseURL + "/kycForm/getOtherBankBranchesList", {},{
            headers:{'X-token':kyc_token}
            })
          .then((response) => {
            console.log("Other Bank List ", response.data);
            this.$root.dataLists.otherBankAndBranchList = Object.values(response.data.banksWithBranches);
            // console.log("this.$root.formData.otherBankAndBranchList", this.$root.formData.otherBankAndBranchList);
            
          })
    }catch(err){
      console.log(err)
    }
  }


  export function getCountyCodeList(){
    try{
      let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
      this.$http
          .post(this.$baseURL + "/getAllCountries", {},{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            //console.log(response.data.countries);

            this.$root.dataLists.countryCodeListArray = response.data.data.countries;
            this.$root.dataLists.countryCodeListArray.forEach(country =>{
              this.$root.dataLists.countryCodeNumbersListArray.push(country.phone)
            })

            //console.log("new array")
            //console.log(this.$root.formData.countryCodeNumbersListArray)

          })

    }catch(err){
      console.log(err)
    }
  }

//  export function assetsRegexValidator(isAssetIsValid, assetValue){
//     let assetRegEx = /^[\d,]+$/
//     isAssetIsValid =  assetRegEx.test(assetValue)
//     console.log("isAssetIsValid", isAssetIsValid)
//     return isAssetIsValid
         
       
//   }

  


// export default submitPageInputs;